import firebase from 'firebase/app';
import 'firebase/firestore';

export const getProtocolMapping = async () => {
  const { docs: lines } = await firebase.firestore().collection('ssl').get();

  return lines.map((doc) => {
    const { markets = null } = doc.data();

    return {
      line: doc.id,
      markets,
    };
  });
};
